import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const yardaddress = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/yard/{profile}/yard-address',
    app: 'yard'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'yard', model: 'yardaddress' }
    ),
    { }
  )
)()

export { yardaddress, TYPES }
